import { GET_CONTACTS } from "constants/contacts";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_CONTACTS}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
